import React from "react";
import s from "./Checkbox.module.css";
import { clsx } from "../../utils/clsx";

export default function Checkbox({ label, children, className, ...rest }) {
  return (
    <label className={clsx(s.row, className)}>
      <input type="checkbox" className={s.box} {...rest} />
      <span>{label ?? children}</span>
    </label>
  );
}
